import { FC, FormEvent } from 'react';

import { Button, Heading, Paragraph, TextSpacing } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { TextInput } from '@telialt/common-text-input/src';

import { INPUT_NAMES } from '../../constants';
import { LeadSmsConfirmProps, LeadSmsConfirmRequestData } from '../../model';
import { LeadTestID } from '../../test-ids';
import { CodeContainer, ConfirmWrapper } from './LeadSMSConfirm.styles';

type LeadSMSConfirmSpecificProps = {
    isLoading?: boolean;
    initialData?: LeadSmsConfirmRequestData;
    onSubmit: (event: FormEvent) => void;
};

export const LeadSMSConfirm: FC<LeadSmsConfirmProps & LeadSMSConfirmSpecificProps> = ({
    smsConfirmDescription,
    isLoading,
    initialData,
    onSubmit,
}) => {
    const { t } = useTranslations();

    return (
        <ConfirmWrapper data-test={LeadTestID.LEAD_SMS_CONFIRM}>
            <form name="lead-sms-confirm-form" onSubmit={onSubmit}>
                <TextSpacing>
                    <Heading tag="h2" variant="title-400">
                        {t['lead.sms_confirm.title']}
                    </Heading>
                    {smsConfirmDescription && <Paragraph>{smsConfirmDescription}</Paragraph>}

                    <Paragraph>{t['lead.sms_confirm.sent_code']}</Paragraph>

                    <CodeContainer>
                        <TextInput
                            dataTest={INPUT_NAMES.CONFIRMATION_CODE}
                            name={INPUT_NAMES.CONFIRMATION_CODE}
                            label={t['lead.sms_confirm.code_label']}
                            required={true}
                            requiredErrorMessage={t['lead.message.sms_confirm_code_error']}
                            defaultValue={initialData?.p_confirmation_code || ''}
                        />
                    </CodeContainer>

                    <Button type="submit" variant="primary" loading={isLoading}>
                        {t['lead.sms_confirm.continue']}
                    </Button>
                </TextSpacing>
            </form>
        </ConfirmWrapper>
    );
};
